// Campus photo for /colleges/hofstra-university: CC BY-SA 4.0, by Antony-22, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHofstra_Hall_2021.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/hofstra-university/; credited under the photo.
const photo = {
    "slug": "hofstra-university",
    "alt": "Hofstra Hall and its brick plaza on the Hofstra University campus in Hempstead, New York",
    "src": "/colleges/hofstra-university/campus-1600.webp",
    "srcSmall": "/colleges/hofstra-university/campus-800.webp",
    "srcMid": "/colleges/hofstra-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/hofstra-university/og.jpg",
    "title": "Hofstra Hall 2021",
    "author": "Antony-22",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHofstra_Hall_2021.jpg",
    "read": "2026-10-01"
};

export default photo;
